export default __webpack_public_path__ + "static/media/paymentSuccess.ee9a8309.jpg";